// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-example[data-v-2c00aec0]{padding:50px 0}.vue-example__container[data-v-2c00aec0]{border-width:1px 0 1px 0;border-color:rgba(0,0,0,.3);border-style:solid;padding-top:50px;padding-bottom:50px}", ""]);
// Exports
module.exports = exports;
